import React from "react";
import { Drawer, Result } from "antd";

export const ProfileDrawerComponent = (props) => {
  const { onClose, visible } = props;

  return (
    <>
      <Drawer
        width={640}
        placement="right"
        closable={true}
        onClose={onClose}
        visible={visible}
      >
        <Result
          status="404"
          title="Service Unavailable"
          subTitle="Sorry, this part is under development"
        />
      </Drawer>
    </>
  );
};
